import { useState } from 'react';
import januaryIcon from '../assets/month-icons/january.svg?raw';
import februaryIcon from '../assets/month-icons/february.svg?raw';
import marchIcon from '../assets/month-icons/march.svg?raw';
import mayIcon from '../assets/month-icons/may.svg?raw';
import juneIcon from '../assets/month-icons/june.svg?raw';
import julyIcon from '../assets/month-icons/july.svg?raw';
import augustIcon from '../assets/month-icons/august.svg?raw';
import septemberIcon from '../assets/month-icons/september.svg?raw';
import octoberIcon from '../assets/month-icons/october.svg?raw';
import novemberIcon from '../assets/month-icons/november.svg?raw';
import decemberIcon from '../assets/month-icons/december.svg?raw';

const AnimStyles = () => (
  <style>{`
    @keyframes fl-cloud {
      0%,100% { transform: translateX(0); }
      50%      { transform: translateX(3px); }
    }
    @keyframes fl-pulse {
      0%,100% { transform: scale(1); }
      50%      { transform: scale(1.1); }
    }
    @keyframes fl-sway {
      0%,100% { transform: rotate(-5deg); }
      50%      { transform: rotate(5deg); }
    }
    @keyframes fl-bob {
      0%,100% { transform: translateY(0); }
      50%      { transform: translateY(-4px); }
    }
    @keyframes fl-spin {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }
    @keyframes fl-blink {
      0%,90%,100% { opacity:1; }
      95%          { opacity:0; }
    }
    @keyframes fl-wave {
      0%,100% { transform: scaleX(1) translateY(0); }
      50%      { transform: scaleX(1.05) translateY(-2px); }
    }
    @keyframes fl-leaf {
      0%,100% { transform: rotate(-6deg) translateY(0); }
      50%      { transform: rotate(6deg) translateY(-3px); }
    }
    @keyframes fl-shine {
      0%,100% { opacity:.4; r:3; }
      50%      { opacity:1; r:4.5; }
    }
    /* drifting fall â€” used for snow & leaves: fades in at top,
       drifts down with a gentle rotation, fades out, loops */
    @keyframes fl-fall {
      0%   { transform: translateY(-10px) rotate(0deg); opacity: 0; }
      15%  { opacity: 1; }
      85%  { opacity: 1; }
      100% { transform: translateY(40px) rotate(160deg); opacity: 0; }
    }
    /* quick raindrop fall â€” short, fast, for monsoon rain */
    @keyframes fl-rain {
      0%   { transform: translateY(0); opacity: 0; }
      20%  { opacity: 1; }
      75%  { opacity: 1; }
      100% { transform: translateY(10px); opacity: 0; }
    }
    /* a sprout breathing as it grows */
    @keyframes fl-grow {
      0%,100% { transform: scaleY(1); }
      50%      { transform: scaleY(1.05); }
    }
    /* a flame flickering in a balloon burner */
    @keyframes fl-flicker {
      0%,100% { transform: scaleY(1) scaleX(1); opacity: 1; }
      50%      { transform: scaleY(1.18) scaleX(0.88); opacity: 0.85; }
    }
    /* a compass needle hunting for north before it settles */
    @keyframes fl-seek {
      0%   { transform: rotate(-12deg); }
      30%  { transform: rotate(16deg); }
      55%  { transform: rotate(-6deg); }
      75%  { transform: rotate(8deg); }
      100% { transform: rotate(-12deg); }
    }
    @keyframes slideDown {
      from { opacity:0; transform:translateY(-10px); }
      to   { opacity:1; transform:translateY(0); }
    }
    @keyframes month-bob {
      0%,100% { transform: translateY(0) scale(1); }
      50% { transform: translateY(-3px) scale(1.03); }
    }
    @keyframes month-pulse {
      0%,100% { transform: scale(1); }
      50% { transform: scale(1.07); }
    }
    @keyframes month-sway {
      0%,100% { transform: rotate(-4deg) translateY(0); }
      50% { transform: rotate(4deg) translateY(-2px); }
    }
    @keyframes month-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    @keyframes month-cloud {
      0%,100% { transform: translateX(0) translateY(0); }
      50% { transform: translateX(2px) translateY(-1px); }
    }
    @keyframes month-leaf {
      0%,100% { transform: rotate(-6deg) translateY(0); }
      50% { transform: rotate(6deg) translateY(-2px); }
    }
    .month-icon-wrap {
      filter: brightness(0) invert(1);
      transform-origin: center;
      will-change: transform;
      overflow: visible;
    }
    .month-icon-wrap svg {
      width: 100% !important;
      height: 100% !important;
      display: block;
      transform-origin: center;
    }
    .month-icon-bob { animation: month-bob 2.8s ease-in-out infinite; }
    .month-icon-pulse { animation: month-pulse 2.2s ease-in-out infinite; }
    .month-icon-sway { animation: month-sway 3s ease-in-out infinite; }
    .month-icon-large svg {
      width: 150% !important;
      height: 150% !important;
    }
    .month-icon-spin { animation: month-spin 9s linear infinite; }
    .month-icon-dec-spin { animation: month-spin 4.5s linear infinite; }
    .month-icon-cloud { animation: month-cloud 3.4s ease-in-out infinite; }
    .month-icon-leaf { animation: month-leaf 2.6s ease-in-out infinite; }
  `}</style>
);


const makeWhiteSvg = (svg) => svg
  .replace(/fill="(?!none)([^"]*)"/gi, 'fill="#ffffff"')
  .replace(/stroke="(?!none)([^"]*)"/gi, 'stroke="#ffffff"');

const MonthIcon = (svg, motionClass = '') => () => (
  <span
    className={`month-icon-wrap h-full w-full ${motionClass}`}
    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    dangerouslySetInnerHTML={{ __html: makeWhiteSvg(svg) }}
  />
);

const MonthImageIcon = (src, motionClass = '') => () => (
  <span
    className={`month-icon-wrap h-full w-full ${motionClass}`}
    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <img src={src} alt="" className="h-full w-full object-contain" loading="lazy" decoding="async" />
  </span>
);

const aprilNaturalFoodIcon = 'https://img.icons8.com/?size=160&id=6dt1eBOsdsLg&format=png&color=000000';

const ICONS = {
  January: MonthIcon(januaryIcon, 'month-icon-bob'),
  February: MonthIcon(februaryIcon, 'month-icon-pulse'),
  March: MonthIcon(marchIcon, 'month-icon-sway month-icon-large'),
  April: MonthImageIcon(aprilNaturalFoodIcon, 'month-icon-bob'),
  May: MonthIcon(mayIcon, 'month-icon-spin'),
  June: MonthIcon(juneIcon, 'month-icon-pulse'),
  July: MonthIcon(julyIcon, 'month-icon-bob'),
  August: MonthIcon(augustIcon, 'month-icon-cloud'),
  September: MonthIcon(septemberIcon, 'month-icon-sway'),
  October: MonthIcon(octoberIcon, 'month-icon-leaf'),
  November: MonthIcon(novemberIcon, 'month-icon-bob'),
  December: MonthIcon(decemberIcon, 'month-icon-dec-spin'),
};

/* Icon background colours per month */
const iconBg = {
  January:   '#A6174B',
  February:  '#F04679',
  March:     '#FF9320',
  April:     '#FFCE48',
  May:       '#C3BA2F',
  June:      '#6398A9',
  July:      '#FBF3E6',
  August:    '#FAF3E3',
  September: '#F7F0E6',
  October:   '#F8F0E3',
  November:  '#F3ECE3',
  December:  '#EEF1F0',
};

const iconBgDark = {
  January:   '#9055A2',
  February:  '#F04679',
  March:     '#C86A00',
  April:     '#C08C00',
  May:       '#8B8421',
  June:      '#3E7486',
  July:      '#845A6D',
  August:    '#5C7457',
  September: '#5F5980',
  October:   '#FF5A5F',
  November:  '#C08552',
  December:  '#5F955E',
};

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-3.5 h-3.5 flex-shrink-0">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
  </svg>
);
const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
  </svg>
);
const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.6 9h16.8M3.6 15h16.8" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a17 17 0 00-6 9 17 17 0 006 9 17 17 0 006-9 17 17 0 00-6-9z" />
  </svg>
);

export const getawaysData = [
  { month:"January",   india:[{name:"Best places to visit in January",  link:"https://travel.rethinkways.com/30-best-places-to-visit-in-january-in-india/"},{name:"Top 10 places to visit in January",  link:"https://travel.rethinkways.com/january-in-india-2026/"}],  international:[{name:"Best Countries to Visit in January",  link:"https://travel.rethinkways.com/travel-in-january-travelrethink-ways/"}]},
  { month:"February",  india:[{name:"Best places to visit in February", link:"https://travel.rethinkways.com/places-to-visit-in-february-2026-in-india/"},{name:"Top 10 places to visit in February", link:"https://travel.rethinkways.com/explore-february-travel-rethink-ways/"}], international:[{name:"Best Countries to Visit in February", link:"https://travel.rethinkways.com/travel-in-february-travel-rethink-ways/"}]},
  { month:"March",     india:[{name:"Best places to visit in March",    link:"https://travel.rethinkways.com/places-to-visit-in-india-in-march-2026/"},{name:"Top 10 places to visit in March",    link:"https://travel.rethinkways.com/travel-in-march-travel-rethink-ways/"}],    international:[{name:"Best Countries to Visit in March",    link:"https://travel.rethinkways.com/vacation-in-march-travel-rethink-ways/"}]},
  { month:"April",     india:[{name:"Best places to visit in April",    link:"https://travel.rethinkways.com/30-best-places-to-visit-in-april-in-india/"},{name:"Top 10 places to visit in April",    link:"https://travel.rethinkways.com/explore-in-april-travel-rethink-ways/"}],    international:[{name:"Best Countries to Visit in April",    link:"https://travel.rethinkways.com/visit-in-april-travelrethink-ways/"}]},
  { month:"May",       india:[{name:"Best places to visit in May",      link:"https://travel.rethinkways.com/best-places-to-visit-in-india-in-may-2026/"},{name:"Top 10 places to visit in May",      link:"https://travel.rethinkways.com/explore-in-may-travel-rethink-ways/"}],      international:[{name:"Best Countries to Visit in May",      link:"https://travel.rethinkways.com/visit-in-may-travel-rethink-ways/"}]},
  { month:"June",      india:[{name:"Best places to visit in June",     link:"https://travel.rethinkways.com/30-best-places-to-visit-in-india-in-june/"},{name:"Top 10 places to visit in June",     link:"https://travel.rethinkways.com/places-to-visit-in-june-in-india/"}],     international:[{name:"Best Countries to Visit in June",     link:"https://travel.rethinkways.com/travel-in-june-travel-rethink-ways/"}]},
  { month:"July",      india:[{name:"Best places to visit in July",     link:"https://travel.rethinkways.com/30-best-places-to-visit-in-india-in-july/"},{name:"Top 10 places to visit in July",     link:"https://travel.rethinkways.com/explore-in-july-travel-rethink-ways/"}],     international:[{name:"Best Countries to Visit in July",     link:"https://travel.rethinkways.com/travel-in-july/"}]},
  { month:"August",    india:[{name:"Best places to visit in August",   link:"https://travel.rethinkways.com/best-places-to-visit-india-in-august-2026/"},{name:"Top 10 places to visit in August",   link:"https://travel.rethinkways.com/explore-in-august/"}],   international:[{name:"Best Countries to Visit in August",   link:"https://travel.rethinkways.com/visit-in-august/"}]},
  { month:"September", india:[{name:"Best places to visit in September",link:"https://travel.rethinkways.com/30-best-places-to-visit-india-in-september/"},{name:"Top 10 places to visit in September",link:"https://travel.rethinkways.com/explore-in-september/"}], international:[{name:"Best Countries to Visit in September",link:"https://travel.rethinkways.com/travel-in-september/"}]},
  { month:"October",   india:[{name:"Best places to visit in October",  link:"https://travel.rethinkways.com/30-best-places-to-visit-in-october-in-india/"},{name:"Top 10 places to visit in October",  link:"https://travel.rethinkways.com/explore-in-october/"}],  international:[{name:"Best Countries to Visit in October",  link:"https://travel.rethinkways.com/travel-in-october/"}]},
  { month:"November",  india:[{name:"Best places to visit in November", link:"https://travel.rethinkways.com/30-best-places-to-visit-november-in-india/"},{name:"Top 10 places to visit in November", link:"https://travel.rethinkways.com/explore-in-november/"}], international:[{name:"Best Countries to Visit in November", link:"https://travel.rethinkways.com/visit-in-november/"}]},
  { month:"December",  india:[{name:"Best places to visit in December", link:"https://travel.rethinkways.com/30-best-places-to-visit-india-in-december/"},{name:"Top 10 places to visit in December", link:"https://travel.rethinkways.com/explore-in-december-travel-rethink-ways/"}], international:[{name:"Best Countries to Visit in December", link:"https://travel.rethinkways.com/international-visit-in-december/"}]},
];

export default function MonthlyGetaways({ isDarkMode = false, onToggleDarkMode }) {
  const [activeIdx, setActiveIdx] = useState(null);
  const [animKey, setAnimKey]     = useState(0);
  const monthBg = iconBgDark;
  const darkerShadeMonths = new Set(['March', 'April', 'May', 'June', 'July', 'December']);

  const handleMonthClick = (i) => {
    if (activeIdx === i) { setActiveIdx(null); }
    else { setActiveIdx(i); setAnimKey(p => p + 1); }
  };

	  const activeData = activeIdx !== null ? getawaysData[activeIdx] : null;
  const useLightHeaderText = activeData ? darkerShadeMonths.has(activeData.month) : false;

  return (
    <div className={isDarkMode ? 'dark' : ''}>
      <AnimStyles />

      <div
        style={{ fontFamily: "'Poppins', sans-serif" }}
        className="w-full bg-white dark:bg-black transition-colors duration-300 py-10"
      >
      <div className="mx-auto w-full max-w-[1470px] space-y-4" style={{ maxWidth: "1470px" }}>

          {/* Month grid */}
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2.5 sm:gap-3 mb-5">
            {getawaysData.map((data, i) => {
              const isActive = activeIdx === i;
              const IconComp = ICONS[data.month];
              return (
                <button
                  key={data.month}
                  onClick={() => handleMonthClick(i)}
	                  className="group relative flex flex-col items-center gap-2.5 py-4 px-2 rounded-2xl border border-[#e5e7eb] dark:border-[#2a2a2a] transition-all duration-200 cursor-pointer focus:outline-none"
	style={{ background: monthBg[data.month] }}
	                >
                  {/* Icon bubble */}
                  <div
                    className="w-16 h-16 rounded-xl flex items-center justify-center p-1.5"
                   style={{ background: 'transparent' }}
                  >
                    <IconComp />
                  </div>

	                 <span className="text-[12px] sm:text-[13px] lg:text-[24px] font-bold leading-none tracking-wide text-white dark:text-white">
                    {data.month}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Expanded panel */}
          {activeData && (() => {
            const IconComp = ICONS[activeData.month];
            return (
              <div
                key={animKey}
                className="w-full max-w-3xl lg:max-w-5xl mx-auto rounded-2xl sm:rounded-3xl overflow-hidden border border-[#e5e7eb] dark:border-[#2a2a2a]"
                style={{ animation: 'slideDown 0.25s cubic-bezier(0.16, 1, 0.3, 1)' }}
              >
                {/* Hero header */}
               <div
  className="px-4 sm:px-8 lg:px-10 py-4 sm:py-8 flex items-center gap-3 sm:gap-5"
	                style={{ background: monthBg[activeData.month] }}
>
                  <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl flex items-center justify-center p-1.5 sm:p-2"
	                       style={{ background: monthBg[activeData.month] }}>
                    <IconComp />
                  </div>
	                  <div className="flex-1 min-w-0">
		                   <p className={`text-[10px] sm:text-[12px] lg:text-[18px] font-semibold uppercase tracking-[0.12em] sm:tracking-[0.15em] mb-1 ${useLightHeaderText ? 'text-white/75' : 'text-black/50 dark:text-white/60'}`}>Monthly Getaway</p>
		<h2 className="text-xl sm:text-3xl font-bold leading-none text-white">{activeData.month}</h2>
	                  </div>
	                  <button
	                    onClick={() => setActiveIdx(null)}
		                   className={`flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center transition-all duration-150 cursor-pointer ${useLightHeaderText ? 'bg-white/15 hover:bg-white/25 text-white' : 'bg-black/10 hover:bg-black/20 dark:bg-white/10 dark:hover:bg-white/20 text-black dark:text-white'}`}
	                    aria-label="Close"
	                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Content */}
                <div className="bg-white dark:bg-[#0b0b0b] px-4 sm:px-8 lg:px-10 py-5 sm:py-8">
                  {/* India */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 pb-5 sm:pb-6 border-b border-[#f0f0f0] dark:border-[#1e1e1e]">
                    <div className="flex items-center gap-2.5 sm:gap-3 w-full sm:w-48 lg:w-52 flex-shrink-0">
                      <span className="inline-flex h-9 w-9 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-full bg-[#D02525]/10 dark:bg-[#D02525]/20 text-[#D02525]"><MapPinIcon /></span>
                      <span className="whitespace-nowrap text-[12px] md:text-[12px] lg:text-[16px] font-bold text-gray-900 dark:text-white uppercase tracking-[0.14em]">India</span>
                    </div>
                    <div className="flex w-full flex-wrap gap-2.5 sm:flex-nowrap sm:flex-1 sm:min-w-0">
                      {activeData.india.map((item, idx) => (
                        <a key={idx} href={item.link} target="_blank" rel="noopener noreferrer"
                           className="group/chip inline-flex max-w-full min-w-0 items-center justify-start gap-2 lg:gap-2 xl:gap-2.5 px-3.5 sm:px-4 lg:px-3 xl:px-4 py-3 rounded-xl bg-[#fafafa] dark:bg-[#111111] border border-[#e8e8e8] dark:border-[#272727] hover:border-[#D02525] hover:bg-[#D02525]/5 dark:hover:border-[#D02525] dark:hover:bg-[#D02525]/10 transition-all duration-150 cursor-pointer">
                          <span className="min-w-0 text-[13px] sm:text-[14px] lg:text-[16px] xl:text-[15px] leading-snug font-semibold text-gray-800 dark:text-gray-200 group-hover/chip:text-[#D02525] transition-colors duration-150 sm:truncate sm:whitespace-nowrap">{item.name}</span>
                          <span className="text-gray-400 group-hover/chip:text-[#D02525] transition-colors duration-150"><ArrowIcon /></span>
                        </a>
                      ))}
                    </div>
                  </div>
                  {/* International */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 pt-5 sm:pt-6">
                    <div className="flex items-center gap-2.5 sm:gap-3 w-full sm:w-48 lg:w-52 flex-shrink-0">
                      <span className="inline-flex h-9 w-9 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-full bg-[#D02525]/10 dark:bg-[#D02525]/20 text-[#D02525]"><GlobeIcon /></span>
                      <span className="whitespace-nowrap text-[12px] md:text-[12px] lg:text-[16px] font-bold text-gray-900 dark:text-white uppercase tracking-[0.14em]">International</span>
                    </div>
                    <div className="flex w-full flex-wrap gap-2.5 sm:flex-nowrap sm:flex-1 sm:min-w-0">
                      {activeData.international.map((item, idx) => (
                        <a key={idx} href={item.link} target="_blank" rel="noopener noreferrer"
                           className="group/chip inline-flex max-w-full min-w-0 items-center justify-start gap-2.5 px-3.5 sm:px-4 py-3 rounded-xl bg-[#fafafa] dark:bg-[#111111] border border-[#e8e8e8] dark:border-[#272727] hover:border-[#D02525] hover:bg-[#D02525]/5 dark:hover:border-[#D02525] dark:hover:bg-[#D02525]/10 transition-all duration-150 cursor-pointer">
                          <span className="min-w-0 text-[13px] sm:text-[14px] lg:text-[16px] leading-snug font-semibold text-gray-800 dark:text-gray-200 group-hover/chip:text-[#D02525] transition-colors duration-150 sm:truncate sm:whitespace-nowrap">{item.name}</span>
                          <span className="text-gray-400 group-hover/chip:text-[#D02525] transition-colors duration-150"><ArrowIcon /></span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

        </div>
      </div>
    </div>
  );
}
